import PropTypes from 'prop-types';
import React from 'react';
import { IMAGE_CDN_URL } from '../../../utilities/imageCDN';

import './SVGFromCloudinary.scss';

const DIGIT_REGEX = /\/?v[0-9]*\//;

export default class SVGFromCloudinary extends React.PureComponent {
    static propTypes = {
        /**
         * Image Source (Cloudinary Id)
         * */
        cloudinaryID: PropTypes.string.isRequired,
        className: PropTypes.string,
        /**
         * Image Alt
         * */
        alt: PropTypes.string,
        transformString: PropTypes.string,
    };

    static defaultProps = {
        alt: '',
        transformString: '',
        className: '',
    };

    render() {
        const baseCls = 'component-Elements-SVGFromCloudinary';
        const transforms = this.props.transformString || '';
        const src = `${IMAGE_CDN_URL}${transforms}/v1${this.props.cloudinaryID.replace(
            DIGIT_REGEX,
            '/'
        )}`;

        return (
            <img
                className={`${baseCls} ${this.props.className}`}
                src={src}
                alt={this.props.alt}
            />
        );
    }
}
